export const SEMPROR_PROJECTS = [
  'df948717-c0cf-41da-b8d1-339db95f391c'
];

export const ALL_VALE_PROJECTS = [
  ...SEMPROR_PROJECTS,
  'af22bc32-e31e-44be-b910-8f5925f97753',
  'fbc5eddf-4c1f-4235-8351-6f08c8868d07',
  'e399728a-523e-4f5c-bdbe-93b3c0247592',
  '5b115427-65b1-43f9-a170-87907697fb67',
  '6f540aff-94b0-4307-95a8-8664bad2e2cf',
  '6229706d-b5d5-4b90-a537-34fb90bc7117',
  'efeddb69-1e9f-4dae-b102-bf1f2de21003',
  'edcb68a4-c17d-4e65-b63f-132175bba118',
  '2097789a-9a2f-4ae0-a346-26eb2da0e055',
  '5ad00946-d439-4ad5-8754-fe1a6aa6cfd6',
  'a5ead5e3-48e2-4a15-94dd-395158c18baf',
  '2072ed4d-526e-4f8a-b549-ff67ebccad18',
  '3bc67f9b-1aa0-486a-9224-7dda6aea3d56',
  'd2f008f1-5ef8-4caf-9871-c3ba5e6e3a8b',
  'b4fce4ea-47d2-4fc8-92b2-5637617f4b4d',
  'dd532b8b-012e-4f77-a9d7-a0a8d7d92804',
  'cd192c5d-dcfd-416f-9e64-97ba77ae4cf0',
  'e59a90f3-bbd7-4a65-a9dc-bdf54bfdced9',
  '25ccd95b-5b6d-41d7-9010-d2c9d0f7480e',
  '49f4b29d-b64d-4c50-bbab-fa9f794b2928',
  '6a7e2c29-5a14-4422-a454-b8ce7873e82b',
  '1f0a8635-cdcc-4271-aa21-72cb00186c1e',
  'f422d319-6bcb-4b22-86c4-8808d24875e6',
  'ab47e189-5173-48bf-9304-7c998a122127',
  '4700d19e-205f-4653-b013-bca713c75267',
  '808363a9-77f6-41a0-9ce2-8696bba67846',
  'cec9fa16-2b9a-49a3-9e22-f6173ebf8f27',
  '4f21a935-dad1-4a84-87c1-ce8b553fe8d3',
  '5ab821cb-0e09-4187-861a-9d5db9a18bfd',
  'ffc83652-6023-4020-82f6-3031100c77d7',
  '83ccd885-4892-4933-b568-84b7b01bb89d',
  '5a9398bb-1381-4d85-a3ab-9cde789626c9',
  'a89f1a96-f023-4a91-a7b5-6ce2ba717ccd',
  '1cab5e4d-91a0-4cff-84c0-8c237084b1ec',
  'e114aed1-770d-4b5e-9c8d-684b4287575d',
  'fd528541-2e21-4852-9dc6-fc4737ce5414'
];

export const CUIA_PROJECTS = [
  ...ALL_VALE_PROJECTS.slice(1)
];